// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_container__KtvCA","loader":"loader__AcN4O","spin":"spin__Evvn5"};